import React from 'react';

import { ChevronRight } from '../../icons';
import type { ICardButtonProps } from './ICardButtonProps';

const CardButton = React.forwardRef<HTMLButtonElement, ICardButtonProps>(
  (props: ICardButtonProps, forwardRef) => {
    const { title, subtitle, icon: Icon = null, iconUrl, ...rest } = props;

    if (Icon && iconUrl) {
      throw new Error('Card button cannot use both icon and iconUrl');
    }

    return (
      <button
        className="border-mobile-gray-100 flex w-full items-center gap-3 rounded-2xl border bg-white px-4 py-3"
        ref={forwardRef}
        {...rest}
      >
        {Icon || null}
        {iconUrl ? (
          <img
            src={iconUrl}
            alt="card-image"
            height={48}
            width={48}
            className="h-12 w-12"
            loading="eager"
          />
        ) : null}
        <span>
          <h2 className="block text-start font-semibold text-gray-600">
            {title}
          </h2>
          {subtitle ? (
            <p className="text-mobile-gray-500 mt-1 block text-start text-sm">
              {subtitle}
            </p>
          ) : null}
        </span>
        <span className="ml-auto block">
          <ChevronRight color="#C5CCD6" />
        </span>
      </button>
    );
  }
);

CardButton.displayName = 'CardButton';

export default CardButton;
